module.exports = __webpack_public_path__ + "img/ado-inperson.f99833fa.png";